import { render, staticRenderFns } from "./TestCardGrid.vue?vue&type=template&id=990528fa"
import script from "./TestCardGrid.vue?vue&type=script&lang=js"
export * from "./TestCardGrid.vue?vue&type=script&lang=js"
import style0 from "./TestCardGrid.vue?vue&type=style&index=0&id=990528fa&prod&lang=css"
import style1 from "./TestCardGrid.vue?vue&type=style&index=1&id=990528fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports